"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phProductsInArrCheck = void 0;
const isPhysicalProduct_1 = require("./isPhysicalProduct");
const phProductsInArrCheck = (lineItems) => lineItems.reduce((acc, lineItem) => {
    if (acc.hasPhProduct && acc.hasBasicPhProduct && acc.hasPhSubscriptionProduct)
        return acc;
    const { isPhProduct, isBasicPhProduct, isPhSubscriptionProduct } = (0, isPhysicalProduct_1.isPhysicalProduct)(lineItem.variant.attributes);
    if (isPhProduct)
        acc.hasPhProduct = isPhProduct;
    if (isBasicPhProduct)
        acc.hasBasicPhProduct = isBasicPhProduct;
    if (isPhSubscriptionProduct)
        acc.hasPhSubscriptionProduct = isPhSubscriptionProduct;
    return acc;
}, { hasPhProduct: false, hasBasicPhProduct: false, hasPhSubscriptionProduct: false });
exports.phProductsInArrCheck = phProductsInArrCheck;
//# sourceMappingURL=phProductsInArrCheck.js.map